import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = {
    product: ProductModel;
};

const PromotionalBadges: FC<Props> = ({ product }) => {
    if (!product || !product.promotionalBadgePaths || product.promotionalBadgePaths.length < 1) {
        return null;
    }

    const wrapperCss: InjectableCss = {
        css: css`
            display: flex;
            img {
                width: auto;
                max-height: 40px;
            }
        `,
    };
    return (
        <StyledWrapper {...wrapperCss}>
            {product.promotionalBadgePaths.map((path, index) => (
                <>
                    <img key={path} src={path} alt="" />
                </>
            ))}
        </StyledWrapper>
    );
};

export default PromotionalBadges;
